import _jsx from "@babel/runtime-corejs3/helpers/esm/jsx";

var _Heading;

/*
 * Copyright (C) 2024 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import React from 'react';
import formatMessage from '../../../../format-message';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { Heading } from '@instructure/ui-heading';
import { Modal } from '@instructure/ui-modal';

const AIResponseModal = _ref => {
  let {
    open,
    html,
    onClose,
    onInsert,
    onReplace
  } = _ref;
  return /*#__PURE__*/_jsx(Modal, {
    open: open,
    onDismiss: onClose,
    size: "medium",
    label: formatMessage('AI Response')
  }, void 0, /*#__PURE__*/_jsx(Modal.Header, {}, void 0, /*#__PURE__*/_jsx(CloseButton, {
    onClick: onClose,
    placement: "end",
    offset: "medium",
    screenReaderLabel: formatMessage('Close')
  }), _Heading || (_Heading = /*#__PURE__*/_jsx(Heading, {
    level: "h3"
  }, void 0, "AI Response"))), /*#__PURE__*/_jsx(Modal.Body, {}, void 0, /*#__PURE__*/_jsx("div", {
    dangerouslySetInnerHTML: {
      __html: html
    }
  })), /*#__PURE__*/_jsx(Modal.Footer, {}, void 0, /*#__PURE__*/_jsx(Button, {
    onClick: onClose,
    margin: "medium 0 0 0"
  }, void 0, formatMessage('Close')), /*#__PURE__*/_jsx(Button, {
    onClick: onReplace,
    margin: "medium 0 0 medium"
  }, void 0, formatMessage('Replace')), /*#__PURE__*/_jsx(Button, {
    onClick: onInsert,
    color: "primary",
    margin: "medium 0 0 medium"
  }, void 0, formatMessage('Insert'))));
};

export { AIResponseModal };